import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Container, Typography } from '@mui/material';

import { withStyles } from '@mui/styles'

import { PublicOfferFilter, PublicOfferTable } from '../../../../features/public-offer'
import { useCombos } from '../../../../features/combos/hooks'
import { PUBLIC_OFFER_COMBOS_IDS } from '../../constants'
import { publicOfferDashboardStyles } from './public-offer-dashboard.styles'

export const PublicOfferDashboardPage = withStyles(publicOfferDashboardStyles)(({ classes }) => {
  useCombos(PUBLIC_OFFER_COMBOS_IDS)
  const { formatMessage } = useIntl()

  return (
    <Container className={classes.container} maxWidth="false">
      <Box mb={2}>
        <Typography variant="h4" color="textSecondary">
          {formatMessage({ id: 'pages.public.offer.dashboard.title' })}
        </Typography>
      </Box>
      <Box mb={2} display="flex">
        <PublicOfferFilter />
      </Box>
      <Box>
        <PublicOfferTable />
      </Box>
    </Container>
  )
})
